import { CanActivateChildFn } from '@angular/router';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { inject } from '@angular/core';

export const FEATURE_FLAG_KEY = 'featureFlag';

export const pathAllowedByFeatureFlagGuard: CanActivateChildFn = route => {
  const featureFlagService = inject(FeatureFlagsService);
  const featureFlagValueEnabled = featureFlagService.getFeatureFlagValue(
    route.data[FEATURE_FLAG_KEY]
  );
  return featureFlagValueEnabled;
};
